export class RestEndPoints {

  public static URL_SEPARATER = '/';

  public static GET_DOMAIN: string = RestEndPoints.URL_SEPARATER + 'domain';

  public static GET_DOMAIN_BY_ID: string = '/domains';

  public static GET_DOMAIN_OPEN_CHANGE_REQUESTS_BY_ID: string = RestEndPoints.URL_SEPARATER + 'opencr';

  public static GET_DOMAIN_DIFF: string = '/domains/changediff';

  public static GET_DIFF_AND_SPLIT: string = '/domains/splitAndDiff';

  public static COMMON_COMMAND: string = RestEndPoints.URL_SEPARATER + 'command';

  public static RESET_PASSWORD: string = RestEndPoints.URL_SEPARATER + 'resetPassword';

  public static RECOVER_USERNAME: string = RestEndPoints.URL_SEPARATER + 'recoverUserName';

  public static GET_CHANGE_REQUESTS: string = RestEndPoints.URL_SEPARATER + 'getChangeRequests';

  public static GET_LIST_OF_DOMAINS: string = '/domains';

  public static GET_CHANGE_REQUEST_DETAILS: string = RestEndPoints.URL_SEPARATER + 'changeRequest' + RestEndPoints.URL_SEPARATER;

  public static AC_TC_CONFIRMATION: string = RestEndPoints.URL_SEPARATER + 'changeRequest' + RestEndPoints.URL_SEPARATER + 'contactConfirmation';

  public static GET_TECH_CHECK_RESULT_DETAILS: string = RestEndPoints.URL_SEPARATER + 'techCheckResult' + RestEndPoints.URL_SEPARATER;

  public static GET_TLD_MANAGER_USER_BY_EMAIL: string = RestEndPoints.URL_SEPARATER + 'tldManagerUserByEmail' + RestEndPoints.URL_SEPARATER;

  public static GET_USER_AUDIT_LOG: string = '/audit';

  public static GET_CURRENT_USER_AUDIT_LOG: string = "/currentUserAuditLog";

  public static GET_USER_LOGIN_ACTIVITY: string = RestEndPoints.URL_SEPARATER + 'loginHistory' + RestEndPoints.URL_SEPARATER;

  public static USERS: string = '/users' + RestEndPoints.URL_SEPARATER;

  public static GET_USER_BY_ID: string = '/users' + RestEndPoints.URL_SEPARATER;

  public static GET_CURRENT_USER_UNAUTHENTICATED_REQUEST: string = RestEndPoints.URL_SEPARATER + 'getCurrentUserFromHeader';

  public static GET_CURRENT_USER: string = RestEndPoints.URL_SEPARATER + 'currentUser';

  public static VALIDATE_NAMESERVERS: string = RestEndPoints.URL_SEPARATER + 'validate' + RestEndPoints.URL_SEPARATER + 'nameServer';

  public static VALIDATE_TRUST_ANCHORS: string = RestEndPoints.URL_SEPARATER + 'validate' + RestEndPoints.URL_SEPARATER + 'trustAnchor';

  public static VALIDATE_ADDITIONAL_INFO: string = RestEndPoints.URL_SEPARATER + 'validate' + RestEndPoints.URL_SEPARATER + 'additionalInfo';

  public static VALIDATE_CONTACT_INFO: string = RestEndPoints.URL_SEPARATER + 'validate' + RestEndPoints.URL_SEPARATER + 'contactInfo';

  public static VALIDATE_SPONSORINGORG: string = RestEndPoints.URL_SEPARATER + 'validate' + RestEndPoints.URL_SEPARATER + 'organization';
}
